import { createSelector, PayloadAction } from "@reduxjs/toolkit";

/** A task to fetch a resource from the server. **/
export interface ResourceTask {
    id: string;
    description: string;
}

export interface TaskState {
    tasks: ResourceTask[];
}

export const taskReducers = {
    addTask: (state: TaskState, action: PayloadAction<ResourceTask>) => {
        state.tasks.push(action.payload);
    },
    removeTask: (state: TaskState, action: PayloadAction<string>) => {
        state.tasks = state.tasks.filter(task => task.id !== action.payload);
    }
};

export const selectTask = createSelector(
    [
      (state: TaskState) => state.tasks, 
      (_: any, taskId: string) => taskId
    ],
    (tasks, taskId) => tasks.find(task => task.id === taskId)
  );

export const Upload1040Task: ResourceTask = { id: "upload1040", description: "Upload 1040" };
export const UploadW2Task: ResourceTask = { id: "uploadW2", description: "Upload W2" };
export const UploadSchedule1Task: ResourceTask = { id: "uploadSchedule1", description: "Upload Schedule 1" };
export const UploadScheduleCTask: ResourceTask = { id: "uploadScheduleC", description: "Upload Schedule C" };

export const Validate1040IncomeTask: ResourceTask = { id: "validate1040", description: "Validate whether 1040 has income" };

export const Confirm1040Task: ResourceTask = { id: "confirm1040", description: "Confirm 1040" };
export const ConfirmW2Task: ResourceTask = { id: "confirmW2", description: "Confirm W2" };
export const ConfirmSchedule1Task: ResourceTask = { id: "confirmSchedule1", description: "Confirm Schedule 1" };
export const ConfirmScheduleCTask: ResourceTask = { id: "confirmScheduleC", description: "Confirm Schedule C" };

export const Delete1040Task: ResourceTask = { id: "delete1040", description: "Delete 1040" };
export const DeleteW2Task: ResourceTask = { id: "deleteW2", description: "Delete W2" };
export const DeleteSchedule1Task: ResourceTask = { id: "deleteSchedule1", description: "Delete Schedule 1" };
export const DeleteScheduleCTask: ResourceTask = { id: "deleteScheduleC", description: "Delete Schedule C" };

export const FetchReturnsTask: ResourceTask = { id: "fetchReturns", description: "Fetch Returns" };
export const DownloadReturnTask: ResourceTask = { id: "downloadReturn", description: "Download Return" };
